export const assets = {
  logo3d: 'https://cdn.magicpatterns.com/uploads/pGzTbi5XoNEd3UqFgfFqA1/3d_logo-1.gif',
  footerLogo: 'https://cdn.magicpatterns.com/uploads/iN9pPkexPM2AHF285Q2cKR/Gruppe-9228.svg',
  arrow: 'https://cdn.magicpatterns.com/uploads/unFBonCSRnDuFFisFGvF5o/arrow-faq.svg',
  navBg: 'https://cdn.magicpatterns.com/uploads/p4hKa22EBKh6cKWMmsm51R/nav_bg.webp',
  heroVideo: 'https://cdn.magicpatterns.com/uploads/12TmtFwc4kjrKNnNKFiUAg/showreel-short-preview-1-transcode.webm',
  heroPoster: 'https://cdn.magicpatterns.com/uploads/4WVNoE6BShKUQeutcDYsoS/showreel-short-preview-1-poster-00001.jpg',
  showreelVideo: 'https://cdn.magicpatterns.com/uploads/hF89wxx41eCLkJUhZcKifw/showreel-preview-mini-transcode.webm',
  showreelPoster: 'https://cdn.magicpatterns.com/uploads/2jFhras6LhqKqih9UyDbnm/showreel-preview-mini-poster-00001.jpg',
  showreelYoutubeId: 'dUx3J9erKPU',
  projectCars: 'https://cdn.magicpatterns.com/uploads/x8fi2KYXi8iU6mXmuxdhxv/Project-Cars.png',
  // Placeholder visuals for projects/posts whose real images did not export from the CMS
  placeholder: {
    jewellery: 'https://cdn.magicpatterns.com/patterns/generated-images/ddd40080-56e8-4a49-b28e-2fb53cdbade6.jpg',
    theatre: 'https://cdn.magicpatterns.com/patterns/generated-images/09d0c474-3213-4d14-b78d-e6c983d6a802.jpg',
    desert: 'https://cdn.magicpatterns.com/patterns/generated-images/1dca1b21-c91d-47b8-8c76-a9c6d70e25b2.jpg',
    researchLab: 'https://cdn.magicpatterns.com/patterns/generated-images/d999e8e2-c487-4e35-aef3-403fe63cc8b6.jpg',
    hauntedHouse: 'https://cdn.magicpatterns.com/patterns/generated-images/54da3c92-dcb0-4132-9d3e-d524c4541fd2.jpg',
  },
  icons: {
    x: 'https://cdn.magicpatterns.com/uploads/7hZEJBPoteTNcPHEh2bD32/layer1.svg',
    youtube: 'https://cdn.magicpatterns.com/uploads/duY8ZkJXL2W9V5oUU2ecNp/Icon-awesome-youtube.svg',
    linkedin: 'https://cdn.magicpatterns.com/uploads/bxrkmUYmwfwpsn419FyJo3/Icon-awesome-linkedin-in.svg',
    discord: 'https://cdn.magicpatterns.com/uploads/gJGrZuotYWBe2PovwfvvVD/Icon-simple-discord.svg',
    awwwards: 'https://cdn.magicpatterns.com/uploads/rfeMq8yTwjrHc1jNatexiR/icon-awwwards.svg',
    dribbble: 'https://cdn.magicpatterns.com/uploads/n9xHaTEFjAM4jH73durwHJ/icon-dribbble.svg',
  },
}

export const contactEmail = 'hey@immersivestudios.de'
